import { isNonEmptyString } from './is-nullish';
import { formatToDecimalString } from './numbers';

export const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

/**
 * Simple pluralizer function(only appending "s") not suitable for words like
 * leaf, life, knife, etc.
 * @param input the thing to pluralize
 * @param quantity the quantity of the things to pluralize
 * @param inclusive should the number be included into the output
 */
export const pluralize = (input: string, quantity: number, inclusive = false) =>
  `${inclusive ? `${formatToDecimalString(quantity)} ` : ''}${input}${quantity === 1 ? '' : 's'}`;

/**
 * Simple pluralizer function(only appending "s") not suitable for words like
 * leaf, life, knife, etc. with the number included in the output.
 * @param input the thing to pluralize
 * @param quantity the quantity of the things to pluralize
 */
export const pluralizeInclusive = (input: string, quantity: number) => pluralize(input, quantity, true);

/**
 * Sorts two strings alphabetically, ignoring case.
 * @param a - The first string to compare
 * @param b - The second string to compare
 * @returns A negative number if a < b, a positive number if a > b, or 0 if they are equal
 */
export const sortAlphabetically = (a: string, b: string) => a.toLowerCase().localeCompare(b.toLowerCase());

/**
 * Returns the first non-empty string from the given array of values.
 * @param values - The array of values to search through.
 * @returns The first non-empty string, or undefined if no non-empty strings are found.
 */
export const firstNonEmptyString = (...values: unknown[]) => values.find((s) => isNonEmptyString(s));
